<!--
 * @Description: 搜索条件
 * @Author: miaofenfen
 * @Date: 2022-07-05 18:00:00
 * @LastEditors: miaofenfen
 * @LastEditTime:2022-07-05 18:00:00
 -->
<template>
	<el-form :rules="rules" :model="formData" ref="queryForm" size="small" :inline="true"
		:label-width="labelWidth ? labelWidth : '100px'" :class="[size ? `search-form ${size}` : 'search-form']"
		@submit.native.prevent>
		<el-form-item v-for="(item, index) in condition" :key="item.key" :label="item.label" :prop="item.key">
			<treeselect v-if="item.type == 'treeselect'" v-model="formData[item.key]" :options="item.options"
				:normalizer="normalizer" :placeholder="`请选择${item.label}`" @input="changeEvent(item, formData[item.key])" />
			<el-input v-if="item.type == 'input'" v-model="formData[item.key]" :clearable="item.clearable"
				:placeholder="`${item.label}`" @keyup.enter.native="handleQuery"
				@change="changeEvent(item, formData[item.key])" />
			<el-input-number v-if="item.type == 'number'" v-model="formData[item.key]" :clearable="item.clearable"
				:placeholder="`${item.label}`" @keyup.enter.native="handleQuery"
				@change="changeEvent(item, formData[item.key])" />
			<el-select v-if="item.type == 'select'" v-model="formData[item.key]" :placeholder="`${item.label}`"
				:clearable="item.clearable" :filterable="item.filterable" @change="changeEvent(item, formData[item.key])">
				<el-option v-for="dict in item.options" :key="dict.dictValue" :label="dict.dictLabel"
					:value="dict.dictValue" />
			</el-select>
			<el-radio-group style="width: 100%;" v-if="item.type == 'radio'" v-model="formData[item.key]"
				@change="changeEvent(item, formData[item.key])">
				<el-radio v-for="dict in item.options" :label="dict.dictLabel" :key="dict.dictValue">{{ dict.dictValue
				}}</el-radio>
			</el-radio-group>
			<el-checkbox-group v-if="item.type == 'checkbox'" v-model="formData[item.key]"
				@change="changeEvent(item, formData[item.key])">
				<el-checkbox v-for="dict in item.options" :label="dict.dictValue" :key="dict.dictValue">{{ dict.dictLabel
				}}</el-checkbox>
			</el-checkbox-group>
			<el-cascader v-if="item.type == 'cascader'" v-model="formData[item.key]" :props="item.props"
				:clearable="item.clearable" filterable :collapse-tags="true" @change="changeEvent(item, formData[item.key])"
				:options="item.options" />
			<el-date-picker v-if="item.type == 'date'" v-model="formData[item.key]" type="date"
				:value-format="item.valueFormat" :format="item.valueFormat" :placeholder="`${item.label}`"
				@change="changeEvent(item, formData[item.key])" style="width: 92%;" />
			<el-date-picker v-if="item.type == 'datetime'" v-model="formData[item.key]" type="datetime"
				:value-format="item.valueFormat" :format="item.valueFormat" :placeholder="`${item.label}`"
				default-time="00:00:00" @change="changeEvent(item, formData[item.key])" />
			<el-date-picker v-if="item.type == 'datetimerange'" v-model="formData[item.key]" type="datetimerange"
				:value-format="item.valueFormat" :format="item.valueFormat" :placeholder="`${item.label}`"
				:default-time="['00:00:00', '23:59:59']" :clearable="item.clearable" start-placeholder="开始日期"
				end-placeholder="结束日期" @change="changeEvent(item, formData[item.key])" />
			<slot v-if="item.slot" :name="item.slot"></slot>
		</el-form-item>
		<!-- <el-form-item label=" "> -->
		<!--  -->
		<!-- 搜索  -->
		<el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"
			style="background: #304156;border-color:#304156;font-family: 'fontStyle';">SEARCH</el-button>
		<!--  重置-->
		<el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
			style="font-family: 'fontStyle';">RESET</el-button>
		<!-- </el-form-item> -->
	</el-form>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
	props: {
		condition: {
			type: Array,
			default: () => []
		},
		formData: {
			type: Object,
			default: () => { }
		},
		labelWidth: {
			type: String,
			default: '100px'
		},
		rules: {
			type: Object,
			default: () => { }
		},
		size: {
			type: String,
			default: ''
		}
	},
	components: { Treeselect },
	data() {
		return {
			showSearch: true
		};
	},
	created() {
		this.$nextTick(() => {
			this.condition.forEach(item => {
				this.$set(this.formData, item.key, item.initValue);
			});
		});
	},
	methods: {
		//组件值变化
		changeEvent(item, e) {
			const { key, type } = item;
			let value = e;
			if (type == 'cascader') {
				this.formData[key] = e[e.length - 1];
				value = e[e.length - 1];
			}
			this.$emit('searchChange', item, value);
		},
		handleQuery() {
			this.$refs['queryForm'].validate(valid => {
				if (valid) {
					this.$emit('search', this.formData);
				}
			});
		},
		resetQuery() {
			this.$emit('reset');
		},
		normalizer(node) {
			if (node.children && !node.children.length) {
				delete node.children;
			}
			return {
				id: node.deptId,
				label: node.deptName,
				children: node.children
			};
		}
	}
};
</script>

<style lang="scss">
.el-card {
	overflow: inherit !important;
	z-index: -999999;
}

.search-form .el-input {
	width: 200px !important;
}

.search-form .el-radio-group {
	width: 200px !important;
}

.search-form .el-checkbox-group {
	width: 200px !important;
}

.search-form .el-input-number {
	width: 200px !important;
}

.search-form .el-input-number .el-input__inner {
	width: 168px !important;
}

.search-form .vue-treeselect {
	width: 200px !important;
	height: 30px !important;
}



.small .el-input {
	width: 120px !important;
}

.small .el-radio-group {
	width: 120px !important;
}

.small .el-checkbox-group {
	width: 120px !important;
}

.small .el-input-number {
	width: 120px !important;
}

.small .el-input-number .el-input__inner {
	width: 168px !important;
}

.small .vue-treeselect {
	width: 140px !important;
	height: 30px !important;
}

// .search-form .el-form-item {
// 	margin-bottom: 10px !important;
// }
.search-form .vue-treeselect__control {
	width: 100%;
	height: 32px;
}

.search-form .el-form-item--medium .el-form-item__content {
	line-height: 30px !important;
}

.el-range-editor--small.el-input__inner {
	width: 510px !important;
}
</style>
